// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1fgsy","label":"LabeledBox_label__NlNoE"};